/* featured-collection-tabs.js - shelf pills of sections/featured-collection.liquid.

   A pill is a link to its shelf's collection, sorted by best selling. Here a
   plain click on it loads that shelf into the SAME carousel instead: the
   section is fetched through the Section Rendering API by its file name on the
   shelf's URL (see the section's header for why that renders the right
   products), the fresh cards replace the track's children, and the pp-slider
   around the track is re-armed so its arrows and progress hairline measure the
   new row. The card galleries are custom elements and arm themselves on insert.

   Modified clicks (new tab, new window) and every failure fall through to the
   link, so a shelf that cannot load in place still opens as a page. A slower
   answer to an earlier click never overwrites a later one: the swap only lands
   if its pill is still the current one when the HTML arrives. Answers are kept
   per URL for the page's life, so going back to a shelf costs no request. */
(() => {
  if (window.ppFeaturedCollectionTabs) return;
  window.ppFeaturedCollectionTabs = true;

  const cache = new Map();

  const load = async (url) => {
    if (cache.has(url)) return cache.get(url);
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(String(res.status));
    const html = await res.text();
    cache.set(url, html);
    return html;
  };

  document.addEventListener('click', async (event) => {
    const pill = event.target.closest('[data-fc-tab]');
    if (!pill) return;
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const slider = pill.closest('pp-slider');
    const track = slider && slider.querySelector('[data-slider-track]');
    if (!track) return;
    event.preventDefault();
    if (pill.getAttribute('aria-current') === 'true') return;

    pill.parentElement.querySelectorAll('[data-fc-tab]').forEach((other) => {
      other.setAttribute('aria-current', other === pill ? 'true' : 'false');
    });
    track.setAttribute('aria-busy', 'true');

    try {
      const html = await load(pill.getAttribute('data-fc-tab'));
      if (pill.getAttribute('aria-current') !== 'true') return;
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-slider-track]');
      if (!fresh || !fresh.children.length) throw new Error('empty shelf');
      track.replaceChildren(...fresh.children);
      track.scrollLeft = 0;
      if (typeof slider.connectedCallback === 'function') slider.connectedCallback();
    } catch (error) {
      window.location.assign(pill.href);
    } finally {
      if (pill.getAttribute('aria-current') === 'true') track.removeAttribute('aria-busy');
    }
  });
})();
